import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import toast from "react-hot-toast";
import { V_URL } from "../../../../BaseUrl";

export const updateAdminPurchaseOrder = createAsyncThunk(
    "/admin/update-admin-po",
    async ({ id, data }, { rejectWithValue }) => {
        try {
            const myurl = `${V_URL}/believe/update-po/${id}`;

            const response = await axios({
                method: "post",
                url: myurl,
                data: data,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("VA_TOKEN"),
                },
            });

            const resData = response.data;
            if (resData.success === true) {
                toast.success(resData.message || "Purchase Order updated successfully");
                return resData;
            } else {
                toast.error(resData.message || "Failed to update Purchase Order");
                return rejectWithValue(resData);
            }
        } catch (error) {
            const message = error.response?.data?.message || error.message || "Something went wrong";
            toast.error(message);
            return rejectWithValue(error.response?.data || message);
        }
    }
);

const updateAdminPurchaseOrderSlice = createSlice({
    name: "updateAdminPurchaseOrder",
    initialState: {
        data: null,
        loading: false,
        error: null,
    },
    reducers: {
        resetUpdatePo: (state) => {
            state.data = null;
            state.loading = false;
            state.error = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(updateAdminPurchaseOrder.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(updateAdminPurchaseOrder.fulfilled, (state, action) => {
                state.data = action.payload;
                state.loading = false;
                state.error = null;
            })
            .addCase(updateAdminPurchaseOrder.rejected, (state, action) => {
                state.data = null;
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export const { resetUpdatePo } = updateAdminPurchaseOrderSlice.actions;
export default updateAdminPurchaseOrderSlice.reducer;
